import { toast } from "react-hot-toast";
import useApi from "../useApi";
import { IResendQuestionResponse } from "./index.type";

const useResendQuestion = () => {
  const { loading: resendingQuestion, makeApiCall } = useApi({
    url: "/rtm/billing-cycle/re-send-question",
    method: "POST",
  });

  const resendQuestion = async ({ patientId }: { patientId: string }) => {
    const { response, error } = await makeApiCall<
      { patientId: string },
      IResendQuestionResponse
    >(
      { patientId },
      `/rtm/billing-cycle/re-send-question?patientId=${patientId}`
    );

    if (response?.status === "success") {
      toast.success(response.message || "Question sent successfully");
      return response;
    }
    const errorMessage = response?.message || error?.msg || "Failed to resend question. Please try again.";
    toast.error(errorMessage);

    return {
      status: "fail" as const,
      message: errorMessage
    };
  };

  return { resendQuestion, resendingQuestion };
};

export default useResendQuestion;
